import { Pipe, Injectable, EventEmitter, Output } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

// tslint:disable-next-line:use-pipe-transform-interface
@Pipe({ name: 'CommonService' })
@Injectable()
export class CommonService {
  constructor(private http: Http) { }

  testToken(): Observable<any> {
    let currentUser = <any>sessionStorage.getItem('auth');
    let headers = new Headers({
      'Authorization': 'Bearer ' + JSON.parse(currentUser).token
    });
    let options = new RequestOptions({ headers: headers });
    return this.http.post('http://localhost:5001/api/auth/testToken', { UserId: JSON.parse(currentUser).UserId }, options)
      .map((response: Response) => {
        var result = <any>response.json();
        return result;
      });
  }

  getApiEndPoint(): any {
    let url = '/api/shared/getkey';
    return this.http.get(url + '?key=API_ENDPOINT')
      .map((response: Response) => {
        return response.json();
      });
  }

  getVersion(): any {
    let url = '/api/shared/getkey';
    return this.http.get(url + '?key=VERSION')
      .map((response: Response) => {
        return response.json();
      });
  }

  // tslint:disable-next-line:member-ordering
  @Output() change: EventEmitter<string> = new EventEmitter();
  click(value: string) {
    // this.value = this.value;
    this.change.emit(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/common.service.ts